import CreatorLiveEventDetailPage from "./CreatorLiveEventDetailPage";

export default CreatorLiveEventDetailPage